// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__Mlcup","tabs":"LayoutWrapperSideNav_tabs__1mZzP","tab":"LayoutWrapperSideNav_tab__2ZQUC"};